import React, { Fragment, useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';

function TendinaEditabile(props) {
    const filter = createFilterOptions();
    const [inputValue, setInputValue] = useState("");
    const [value, setValue] = useState(null);

    useEffect(() => {
        // Imposta il valore iniziale da props
        const found = getValoriPossibili().find(el => el.valore === props.valoreDefault);
        setValue(found || null);
        setInputValue(props.valoreDefault || "");
    }, [props.valoreDefault, props.arrayValori]);

    const getValoriPossibili = () => {
        let valori = [];

        if (!Array.isArray(props.arrayValori)) {
        console.warn("TendinaEditabile: props.arrayValori non è un array", props.arrayValori);
        return valori; // ritorna array vuoto
    }
        if (props.labelCampoVuoto !== undefined)
            valori.push({ valore: props.labelCampoVuoto, valoreNonVisibile: '' });

        if (props.inserisciCampoTutti !== undefined)
            valori.push({ valore: "Tutti", valoreNonVisibile: '' });

        props.arrayValori.forEach((item) => {
            let composizione = "";

            if ((props.nomeCampoParentesi || props.nomeCampo2) &&
                (item[props.nomeCampoParentesi] || item[props.nomeCampo2])) {

                if (item[props.nomeCampo])
                    composizione += item[props.nomeCampo];

                if (item[props.nomeCampo2])
                    composizione += (composizione ? " " : "") + item[props.nomeCampo2];

                if (item[props.nomeCampoParentesi])
                    composizione += (composizione ? " " : "") + `(${item[props.nomeCampoParentesi]})`;

                if (composizione)
                    valori.push({
                        valore: composizione,
                        valoreNonVisibile: item[props.nomeCampoNonVisibile]
                    });
            } else if (item[props.nomeCampo]) {
                valori.push({
                    valore: item[props.nomeCampo],
                    valoreNonVisibile: item[props.nomeCampoNonVisibile]
                });
            }
        });

        return valori;
    };

    const valoriPossibili = getValoriPossibili();

    const handleChange = (event, newValue) => {
        setValue(newValue);

        if (typeof newValue === 'string') {
            props.callbackSetVariazioneCampi(1);
            props.callbackSetValoreTendEditabile(newValue, props.posizioneTendina ?? '', '');
        } else if (!newValue) {
            props.callbackSetVariazioneCampi(1);
            props.callbackSetValoreTendEditabile('', props.posizioneTendina ?? '', '');
        } else if (newValue.inputValue) {
            props.callbackSetVariazioneCampi(1);
            props.callbackSetValoreTendEditabile(newValue.inputValue, props.posizioneTendina ?? '', '');
        } else {
            props.callbackSetVariazioneCampi(1);
            props.callbackSetValoreTendEditabile(newValue.valore, props.posizioneTendina ?? '', newValue.valoreNonVisibile);
        }
    };

    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue);
    };

    return (
        <Fragment>
            <Autocomplete
                autoHighlight
                style={{ backgroundColor: "#FFFFFF" }}
                value={value}
                inputValue={inputValue}
                onChange={handleChange}
                onInputChange={handleInputChange}
                filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const input = params.inputValue?.toUpperCase() ?? "";
                    const alreadyPresent = valoriPossibili.some(el => el.valore.toUpperCase() === input);

                    if (input !== "" && !alreadyPresent && props.bloccoInserimento !== 1) {
                        filtered.push({
                            inputValue: params.inputValue,
                            valore: `Aggiungi ${params.inputValue}`,
                        });
                    }

                    return filtered;
                }}
                selectOnFocus
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={valoriPossibili}
                getOptionLabel={(option) => {
                    if (typeof option === 'string') return option;
                    if (option.inputValue) return option.inputValue;
                    return option.valore;
                }}
                renderOption={(option) => option.valore}
                size="small"
                freeSolo
                renderInput={(params) => (
                    <TextField {...params} label={props.titolo} variant="outlined" />
                )}
            />
        </Fragment>
    );
}

export default TendinaEditabile;
